module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('a', {
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pix"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("And so I appeal to our government:")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("double it, treble it, the guard on this grave.")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_c('em', [_vm._v("—Yevtushenko")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0